import request from '../../../../shared/request'
import moment from 'moment'

export function getJobList(filters) {
  return request(`/reports/maintenance-dob/stop-calls-report/job-list/`)
}

export function getOrganizationList(filters) {
  return request(`/reports/maintenance-dob/stop-calls-report/organization-list/`)
}

export function getFullReport(filters) {
  // mount query string
  let qs = ''

  // add date range
  qs += `?startDate=${moment(filters.date_range[0]).format('YYYY-MM-DD')}&endDate=${moment(
    filters.date_range[1]
  ).format('YYYY-MM-DD')}`

  // add job
  if (filters.job_id) {
    qs += `&job_id=${filters.job_id}`
  }

  // add company id
  if (filters.company_id) {
    qs += `&organization_id=${filters.company_id}`
  }

  // add statuses
  if (filters.statuses && filters.statuses.length > 0) {
    for (const entity of filters.statuses) {
      qs += `&statuses[]=${entity}`
    }
  }

  return request(`/reports/maintenance-dob/stop-calls-report/full-report/${qs}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/reports/maintenance_dob/stopCalls.js